<template>
    <div class="login-wrap" :style="{ background: 'url(' + userData.pc_loginback_img + ')' }">
        <!--        <div class="ms-login">-->
        <!--            <div class="ms-title" @click="go">后台管理系统</div>-->
        <!--            <el-form :model="param" :rules="rules" ref="login" label-width="0px" class="ms-content">-->
        <!--                <el-form-item prop="username">-->
        <!--                    <el-input v-model="param.username" placeholder="username">-->
        <!--                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>-->
        <!--                    </el-input>-->
        <!--                </el-form-item>-->
        <!--                <el-form-item prop="password">-->
        <!--                    <el-input-->
        <!--                        type="password"-->
        <!--                        placeholder="password"-->
        <!--                        v-model="param.password"-->
        <!--                        @keyup.enter.native="submitForm()"-->
        <!--                    >-->
        <!--                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>-->
        <!--                    </el-input>-->
        <!--                </el-form-item>-->
        <!--                <div class="login-btn">-->
        <!--                    <el-button type="primary" @click="submitForm()">登录</el-button>-->
        <!--                </div>-->
        <!--                <p class="login-tips">Tips : 用户名和密码随便填。</p>-->
        <!--            </el-form>-->
        <!--        </div>-->
        <loginPage style="min-width:1200px;min-height: 900px"></loginPage>

    </div>
</template>

<script>
    import loginPage from '../../views/login/login';

    export default {
        data: function() {
            return {
                userData: '',
                param: {
                    username: 'admin',
                    password: '123123'
                },
                rules: {
                    username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                    password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
                }
            };
        },
        components: {
            loginPage
        },
        methods: {

            submitForm() {
                this.$refs.login.validate(valid => {
                    if (valid) {
                        this.$message.success('登录成功');
                        localStorage.setItem('ms_username', this.param.username);
                        this.$router.push('/');
                    } else {
                        this.$message.error('请输入账号和密码');
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        },
        created() {
            this.userData = JSON.parse(localStorage.getItem('userData'));
        }
    };
</script>

<style scoped>
    .login-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background-size: 100% 100% !important;
        /*background-size: cover;*/
        background-position: center center !important;
        overflow: scroll;
    }

    .ms-title {
        width: 100%;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        border-bottom: 1px solid #ddd;
    }

    .ms-login {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 350px;
        margin: -190px 0 0 -175px;
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.3);
        overflow: hidden;
    }

    .ms-content {
        padding: 30px 30px;
    }

    .login-btn {
        text-align: center;
    }

    .login-btn button {
        width: 100%;
        height: 36px;
        margin-bottom: 10px;
    }

    .login-tips {
        font-size: 12px;
        line-height: 30px;
        color: #fff;
    }
</style>
